import * as j from "react/jsx-runtime";
import * as F from "react";
import { forwardRef as cr, useContext as or } from "react";
function ir(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function fr(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var ur = /* @__PURE__ */ function() {
  function e(t) {
    var n = this;
    this._insertTag = function(a) {
      var s;
      n.tags.length === 0 ? n.insertionPoint ? s = n.insertionPoint.nextSibling : n.prepend ? s = n.container.firstChild : s = n.before : s = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(a, s), n.tags.push(a);
    }, this.isSpeedy = t.speedy === void 0 ? !0 : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, r.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(fr(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var s = ir(a);
      try {
        s.insertRule(n, s.cssRules.length);
      } catch {
      }
    } else
      a.appendChild(document.createTextNode(n));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(n) {
      var a;
      return (a = n.parentNode) == null ? void 0 : a.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), P = "-ms-", J = "-moz-", m = "-webkit-", Ce = "comm", fe = "rule", ue = "decl", dr = "@import", we = "@keyframes", lr = "@layer", mr = Math.abs, Q = String.fromCharCode, hr = Object.assign;
function yr(e, r) {
  return R(e, 0) ^ 45 ? (((r << 2 ^ R(e, 0)) << 2 ^ R(e, 1)) << 2 ^ R(e, 2)) << 2 ^ R(e, 3) : 0;
}
function $e(e) {
  return e.trim();
}
function pr(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function h(e, r, t) {
  return e.replace(r, t);
}
function se(e, r) {
  return e.indexOf(r);
}
function R(e, r) {
  return e.charCodeAt(r) | 0;
}
function V(e, r, t) {
  return e.slice(r, t);
}
function I(e) {
  return e.length;
}
function de(e) {
  return e.length;
}
function K(e, r) {
  return r.push(e), e;
}
function vr(e, r) {
  return e.map(r).join("");
}
var ee = 1, D = 1, Te = 0, M = 0, $ = 0, z = "";
function re(e, r, t, n, a, s, i) {
  return { value: e, root: r, parent: t, type: n, props: a, children: s, line: ee, column: D, length: i, return: "" };
}
function W(e, r) {
  return hr(re("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function br() {
  return $;
}
function xr() {
  return $ = M > 0 ? R(z, --M) : 0, D--, $ === 10 && (D = 1, ee--), $;
}
function k() {
  return $ = M < Te ? R(z, M++) : 0, D++, $ === 10 && (D = 1, ee++), $;
}
function L() {
  return R(z, M);
}
function H() {
  return M;
}
function U(e, r) {
  return V(z, e, r);
}
function G(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function _e(e) {
  return ee = D = 1, Te = I(z = e), M = 0, [];
}
function Re(e) {
  return z = "", e;
}
function Z(e) {
  return $e(U(M - 1, ce(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Er(e) {
  for (; ($ = L()) && $ < 33; )
    k();
  return G(e) > 2 || G($) > 3 ? "" : " ";
}
function Sr(e, r) {
  for (; --r && k() && !($ < 48 || $ > 102 || $ > 57 && $ < 65 || $ > 70 && $ < 97); )
    ;
  return U(e, H() + (r < 6 && L() == 32 && k() == 32));
}
function ce(e) {
  for (; k(); )
    switch ($) {
      case e:
        return M;
      case 34:
      case 39:
        e !== 34 && e !== 39 && ce($);
        break;
      case 40:
        e === 41 && ce(e);
        break;
      case 92:
        k();
        break;
    }
  return M;
}
function gr(e, r) {
  for (; k() && e + $ !== 57; )
    if (e + $ === 84 && L() === 47)
      break;
  return "/*" + U(r, M - 1) + "*" + Q(e === 47 ? e : k());
}
function Cr(e) {
  for (; !G(L()); )
    k();
  return U(e, M);
}
function wr(e) {
  return Re(X("", null, null, null, [""], e = _e(e), 0, [0], e));
}
function X(e, r, t, n, a, s, i, f, u) {
  for (var d = 0, l = 0, v = i, O = 0, T = 0, g = 0, x = 1, _ = 1, S = 1, w = 0, E = "", C = a, c = s, A = n, b = E; _; )
    switch (g = w, w = k()) {
      case 40:
        if (g != 108 && R(b, v - 1) == 58) {
          se(b += h(Z(w), "&", "&\f"), "&\f") != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        b += Z(w);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        b += Er(g);
        break;
      case 92:
        b += Sr(H() - 1, 7);
        continue;
      case 47:
        switch (L()) {
          case 42:
          case 47:
            K($r(gr(k(), H()), r, t), u);
            break;
          default:
            b += "/";
        }
        break;
      case 123 * x:
        f[d++] = I(b) * S;
      case 125 * x:
      case 59:
      case 0:
        switch (w) {
          case 0:
          case 125:
            _ = 0;
          case 59 + l:
            S == -1 && (b = h(b, /\f/g, "")), T > 0 && I(b) - v && K(T > 32 ? pe(b + ";", n, t, v - 1) : pe(h(b, " ", "") + ";", n, t, v - 2), u);
            break;
          case 59:
            b += ";";
          default:
            if (K(A = ye(b, r, t, d, l, a, f, E, C = [], c = [], v), s), w === 123)
              if (l === 0)
                X(b, r, A, A, C, s, v, f, c);
              else
                switch (O === 99 && R(b, 3) === 110 ? 100 : O) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    X(e, A, A, n && K(ye(e, A, A, 0, 0, a, f, E, a, C = [], v), c), a, c, v, f, n ? C : c);
                    break;
                  default:
                    X(b, A, A, A, [""], c, 0, f, c);
                }
        }
        d = l = T = 0, x = S = 1, E = b = "", v = i;
        break;
      case 58:
        v = 1 + I(b), T = g;
      default:
        if (x < 1) {
          if (w == 123)
            --x;
          else if (w == 125 && x++ == 0 && xr() == 125)
            continue;
        }
        switch (b += Q(w), w * x) {
          case 38:
            S = l > 0 ? 1 : (b += "\f", -1);
            break;
          case 44:
            f[d++] = (I(b) - 1) * S, S = 1;
            break;
          case 64:
            L() === 45 && (b += Z(k())), O = L(), l = v = I(E = b += Cr(H())), w++;
            break;
          case 45:
            g === 45 && I(b) == 2 && (x = 0);
        }
    }
  return s;
}
function ye(e, r, t, n, a, s, i, f, u, d, l) {
  for (var v = a - 1, O = a === 0 ? s : [""], T = de(O), g = 0, x = 0, _ = 0; g < n; ++g)
    for (var S = 0, w = V(e, v + 1, v = mr(x = i[g])), E = e; S < T; ++S)
      (E = $e(x > 0 ? O[S] + " " + w : h(w, /&\f/g, O[S]))) && (u[_++] = E);
  return re(e, r, t, a === 0 ? fe : f, u, d, l);
}
function $r(e, r, t) {
  return re(e, r, t, Ce, Q(br()), V(e, 2, -2), 0);
}
function pe(e, r, t, n) {
  return re(e, r, t, ue, V(e, 0, n), V(e, n + 1, -1), n);
}
function Y(e, r) {
  for (var t = "", n = de(e), a = 0; a < n; a++)
    t += r(e[a], a, e, r) || "";
  return t;
}
function Tr(e, r, t, n) {
  switch (e.type) {
    case lr:
      if (e.children.length) break;
    case dr:
    case ue:
      return e.return = e.return || e.value;
    case Ce:
      return "";
    case we:
      return e.return = e.value + "{" + Y(e.children, n) + "}";
    case fe:
      e.value = e.props.join(",");
  }
  return I(t = Y(e.children, n)) ? e.return = e.value + "{" + t + "}" : "";
}
function _r(e) {
  var r = de(e);
  return function(t, n, a, s) {
    for (var i = "", f = 0; f < r; f++)
      i += e[f](t, n, a, s) || "";
    return i;
  };
}
function Rr(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function Ar(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var Pr = function(r, t, n) {
  for (var a = 0, s = 0; a = s, s = L(), a === 38 && s === 12 && (t[n] = 1), !G(s); )
    k();
  return U(r, M);
}, Mr = function(r, t) {
  var n = -1, a = 44;
  do
    switch (G(a)) {
      case 0:
        a === 38 && L() === 12 && (t[n] = 1), r[n] += Pr(M - 1, t, n);
        break;
      case 2:
        r[n] += Z(a);
        break;
      case 4:
        if (a === 44) {
          r[++n] = L() === 58 ? "&\f" : "", t[n] = r[n].length;
          break;
        }
      default:
        r[n] += Q(a);
    }
  while (a = k());
  return r;
}, Or = function(r, t) {
  return Re(Mr(_e(r), t));
}, ve = /* @__PURE__ */ new WeakMap(), kr = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, n = r.parent, a = r.column === n.column && r.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !ve.get(n)) && !a) {
      ve.set(r, !0);
      for (var s = [], i = Or(t, s), f = n.props, u = 0, d = 0; u < i.length; u++)
        for (var l = 0; l < f.length; l++, d++)
          r.props[d] = s[u] ? i[u].replace(/&\f/g, f[l]) : f[l] + " " + i[u];
    }
  }
}, Ir = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
};
function Ae(e, r) {
  switch (yr(e, r)) {
    case 5103:
      return m + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return m + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return m + e + J + e + P + e + e;
    case 6828:
    case 4268:
      return m + e + P + e + e;
    case 6165:
      return m + e + P + "flex-" + e + e;
    case 5187:
      return m + e + h(e, /(\w+).+(:[^]+)/, m + "box-$1$2" + P + "flex-$1$2") + e;
    case 5443:
      return m + e + P + "flex-item-" + h(e, /flex-|-self/, "") + e;
    case 4675:
      return m + e + P + "flex-line-pack" + h(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return m + e + P + h(e, "shrink", "negative") + e;
    case 5292:
      return m + e + P + h(e, "basis", "preferred-size") + e;
    case 6060:
      return m + "box-" + h(e, "-grow", "") + m + e + P + h(e, "grow", "positive") + e;
    case 4554:
      return m + h(e, /([^-])(transform)/g, "$1" + m + "$2") + e;
    case 6187:
      return h(h(h(e, /(zoom-|grab)/, m + "$1"), /(image-set)/, m + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return h(e, /(image-set\([^]*)/, m + "$1$`$1");
    case 4968:
      return h(h(e, /(.+:)(flex-)?(.*)/, m + "box-pack:$3" + P + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + m + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return h(e, /(.+)-inline(.+)/, m + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (I(e) - 1 - r > 6) switch (R(e, r + 1)) {
        case 109:
          if (R(e, r + 4) !== 45) break;
        case 102:
          return h(e, /(.+:)(.+)-([^]+)/, "$1" + m + "$2-$3$1" + J + (R(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~se(e, "stretch") ? Ae(h(e, "stretch", "fill-available"), r) + e : e;
      }
      break;
    case 4949:
      if (R(e, r + 1) !== 115) break;
    case 6444:
      switch (R(e, I(e) - 3 - (~se(e, "!important") && 10))) {
        case 107:
          return h(e, ":", ":" + m) + e;
        case 101:
          return h(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + m + (R(e, 14) === 45 ? "inline-" : "") + "box$3$1" + m + "$2$3$1" + P + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (R(e, r + 11)) {
        case 114:
          return m + e + P + h(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return m + e + P + h(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return m + e + P + h(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return m + e + P + e + e;
  }
  return e;
}
var Nr = function(r, t, n, a) {
  if (r.length > -1 && !r.return) switch (r.type) {
    case ue:
      r.return = Ae(r.value, r.length);
      break;
    case we:
      return Y([W(r, {
        value: h(r.value, "@", "@" + m)
      })], a);
    case fe:
      if (r.length) return vr(r.props, function(s) {
        switch (pr(s, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Y([W(r, {
              props: [h(s, /:(read-\w+)/, ":" + J + "$1")]
            })], a);
          case "::placeholder":
            return Y([W(r, {
              props: [h(s, /:(plac\w+)/, ":" + m + "input-$1")]
            }), W(r, {
              props: [h(s, /:(plac\w+)/, ":" + J + "$1")]
            }), W(r, {
              props: [h(s, /:(plac\w+)/, P + "input-$1")]
            })], a);
        }
        return "";
      });
  }
}, Fr = [Nr], Lr = function(r) {
  var t = r.key;
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(x) {
      var _ = x.getAttribute("data-emotion");
      _.indexOf(" ") !== -1 && (document.head.appendChild(x), x.setAttribute("data-s", ""));
    });
  }
  var a = r.stylisPlugins || Fr, s = {}, i, f = [];
  i = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(x) {
      for (var _ = x.getAttribute("data-emotion").split(" "), S = 1; S < _.length; S++)
        s[_[S]] = !0;
      f.push(x);
    }
  );
  var u, d = [kr, Ir];
  {
    var l, v = [Tr, Rr(function(x) {
      l.insert(x);
    })], O = _r(d.concat(a, v)), T = function(_) {
      return Y(wr(_), O);
    };
    u = function(_, S, w, E) {
      l = w, T(_ ? _ + "{" + S.styles + "}" : S.styles), E && (g.inserted[S.name] = !0);
    };
  }
  var g = {
    key: t,
    sheet: new ur({
      key: t,
      container: i,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: s,
    registered: {},
    insert: u
  };
  return g.sheet.hydrate(f), g;
}, oe = { exports: {} }, y = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var be;
function Yr() {
  if (be) return y;
  be = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, O = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, _ = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function E(c) {
    if (typeof c == "object" && c !== null) {
      var A = c.$$typeof;
      switch (A) {
        case r:
          switch (c = c.type, c) {
            case u:
            case d:
            case n:
            case s:
            case a:
            case v:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case f:
                case l:
                case g:
                case T:
                case i:
                  return c;
                default:
                  return A;
              }
          }
        case t:
          return A;
      }
    }
  }
  function C(c) {
    return E(c) === d;
  }
  return y.AsyncMode = u, y.ConcurrentMode = d, y.ContextConsumer = f, y.ContextProvider = i, y.Element = r, y.ForwardRef = l, y.Fragment = n, y.Lazy = g, y.Memo = T, y.Portal = t, y.Profiler = s, y.StrictMode = a, y.Suspense = v, y.isAsyncMode = function(c) {
    return C(c) || E(c) === u;
  }, y.isConcurrentMode = C, y.isContextConsumer = function(c) {
    return E(c) === f;
  }, y.isContextProvider = function(c) {
    return E(c) === i;
  }, y.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, y.isForwardRef = function(c) {
    return E(c) === l;
  }, y.isFragment = function(c) {
    return E(c) === n;
  }, y.isLazy = function(c) {
    return E(c) === g;
  }, y.isMemo = function(c) {
    return E(c) === T;
  }, y.isPortal = function(c) {
    return E(c) === t;
  }, y.isProfiler = function(c) {
    return E(c) === s;
  }, y.isStrictMode = function(c) {
    return E(c) === a;
  }, y.isSuspense = function(c) {
    return E(c) === v;
  }, y.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === n || c === d || c === s || c === a || c === v || c === O || typeof c == "object" && c !== null && (c.$$typeof === g || c.$$typeof === T || c.$$typeof === i || c.$$typeof === f || c.$$typeof === l || c.$$typeof === _ || c.$$typeof === S || c.$$typeof === w || c.$$typeof === x);
  }, y.typeOf = E, y;
}
var p = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xe;
function Dr() {
  return xe || (xe = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, O = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, _ = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function E(o) {
      return typeof o == "string" || typeof o == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      o === n || o === d || o === s || o === a || o === v || o === O || typeof o == "object" && o !== null && (o.$$typeof === g || o.$$typeof === T || o.$$typeof === i || o.$$typeof === f || o.$$typeof === l || o.$$typeof === _ || o.$$typeof === S || o.$$typeof === w || o.$$typeof === x);
    }
    function C(o) {
      if (typeof o == "object" && o !== null) {
        var ne = o.$$typeof;
        switch (ne) {
          case r:
            var B = o.type;
            switch (B) {
              case u:
              case d:
              case n:
              case s:
              case a:
              case v:
                return B;
              default:
                var he = B && B.$$typeof;
                switch (he) {
                  case f:
                  case l:
                  case g:
                  case T:
                  case i:
                    return he;
                  default:
                    return ne;
                }
            }
          case t:
            return ne;
        }
      }
    }
    var c = u, A = d, b = f, Ye = i, De = r, ze = l, We = n, je = g, Ve = T, Ge = t, qe = s, Ue = a, Be = v, le = !1;
    function Ke(o) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), me(o) || C(o) === u;
    }
    function me(o) {
      return C(o) === d;
    }
    function He(o) {
      return C(o) === f;
    }
    function Ze(o) {
      return C(o) === i;
    }
    function Xe(o) {
      return typeof o == "object" && o !== null && o.$$typeof === r;
    }
    function Je(o) {
      return C(o) === l;
    }
    function Qe(o) {
      return C(o) === n;
    }
    function er(o) {
      return C(o) === g;
    }
    function rr(o) {
      return C(o) === T;
    }
    function tr(o) {
      return C(o) === t;
    }
    function nr(o) {
      return C(o) === s;
    }
    function ar(o) {
      return C(o) === a;
    }
    function sr(o) {
      return C(o) === v;
    }
    p.AsyncMode = c, p.ConcurrentMode = A, p.ContextConsumer = b, p.ContextProvider = Ye, p.Element = De, p.ForwardRef = ze, p.Fragment = We, p.Lazy = je, p.Memo = Ve, p.Portal = Ge, p.Profiler = qe, p.StrictMode = Ue, p.Suspense = Be, p.isAsyncMode = Ke, p.isConcurrentMode = me, p.isContextConsumer = He, p.isContextProvider = Ze, p.isElement = Xe, p.isForwardRef = Je, p.isFragment = Qe, p.isLazy = er, p.isMemo = rr, p.isPortal = tr, p.isProfiler = nr, p.isStrictMode = ar, p.isSuspense = sr, p.isValidElementType = E, p.typeOf = C;
  }()), p;
}
process.env.NODE_ENV === "production" ? oe.exports = Yr() : oe.exports = Dr();
var zr = oe.exports, Pe = zr, Wr = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, jr = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Me = {};
Me[Pe.ForwardRef] = Wr;
Me[Pe.Memo] = jr;
var Vr = !0;
function Gr(e, r, t) {
  var n = "";
  return t.split(" ").forEach(function(a) {
    e[a] !== void 0 ? r.push(e[a] + ";") : a && (n += a + " ");
  }), n;
}
var Oe = function(r, t, n) {
  var a = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Vr === !1) && r.registered[a] === void 0 && (r.registered[a] = t.styles);
}, qr = function(r, t, n) {
  Oe(r, t, n);
  var a = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var s = t;
    do
      r.insert(t === s ? "." + a : "", s, r.sheet, !0), s = s.next;
    while (s !== void 0);
  }
};
function Ur(e) {
  for (var r = 0, t, n = 0, a = e.length; a >= 4; ++n, a -= 4)
    t = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      r ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(n) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Br = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Kr = /[A-Z]|^ms/g, Hr = /_EMO_([^_]+?)_([^]*?)_EMO_/g, ke = function(r) {
  return r.charCodeAt(1) === 45;
}, Ee = function(r) {
  return r != null && typeof r != "boolean";
}, ae = /* @__PURE__ */ Ar(function(e) {
  return ke(e) ? e : e.replace(Kr, "-$&").toLowerCase();
}), Se = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(Hr, function(n, a, s) {
          return N = {
            name: a,
            styles: s,
            next: N
          }, a;
        });
  }
  return Br[r] !== 1 && !ke(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
function q(e, r, t) {
  if (t == null)
    return "";
  var n = t;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      var a = t;
      if (a.anim === 1)
        return N = {
          name: a.name,
          styles: a.styles,
          next: N
        }, a.name;
      var s = t;
      if (s.styles !== void 0) {
        var i = s.next;
        if (i !== void 0)
          for (; i !== void 0; )
            N = {
              name: i.name,
              styles: i.styles,
              next: N
            }, i = i.next;
        var f = s.styles + ";";
        return f;
      }
      return Zr(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var u = N, d = t(e);
        return N = u, q(e, r, d);
      }
      break;
    }
  }
  var l = t;
  return l;
}
function Zr(e, r, t) {
  var n = "";
  if (Array.isArray(t))
    for (var a = 0; a < t.length; a++)
      n += q(e, r, t[a]) + ";";
  else
    for (var s in t) {
      var i = t[s];
      if (typeof i != "object") {
        var f = i;
        Ee(f) && (n += ae(s) + ":" + Se(s, f) + ";");
      } else if (Array.isArray(i) && typeof i[0] == "string" && r == null)
        for (var u = 0; u < i.length; u++)
          Ee(i[u]) && (n += ae(s) + ":" + Se(s, i[u]) + ";");
      else {
        var d = q(e, r, i);
        switch (s) {
          case "animation":
          case "animationName": {
            n += ae(s) + ":" + d + ";";
            break;
          }
          default:
            n += s + "{" + d + "}";
        }
      }
    }
  return n;
}
var ge = /label:\s*([^\s;{]+)\s*(;|$)/g, N;
function Xr(e, r, t) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var n = !0, a = "";
  N = void 0;
  var s = e[0];
  if (s == null || s.raw === void 0)
    n = !1, a += q(t, r, s);
  else {
    var i = s;
    a += i[0];
  }
  for (var f = 1; f < e.length; f++)
    if (a += q(t, r, e[f]), n) {
      var u = s;
      a += u[f];
    }
  ge.lastIndex = 0;
  for (var d = "", l; (l = ge.exec(a)) !== null; )
    d += "-" + l[1];
  var v = Ur(a) + d;
  return {
    name: v,
    styles: a,
    next: N
  };
}
var Jr = function(r) {
  return r();
}, Ie = F.useInsertionEffect ? F.useInsertionEffect : !1, Qr = Ie || Jr, st = Ie || F.useLayoutEffect, Ne = /* @__PURE__ */ F.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Lr({
    key: "css"
  }) : null
);
Ne.Provider;
var et = function(r) {
  return /* @__PURE__ */ cr(function(t, n) {
    var a = or(Ne);
    return r(t, a, n);
  });
}, rt = /* @__PURE__ */ F.createContext({}), te = {}.hasOwnProperty, ie = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Fe = function(r, t) {
  var n = {};
  for (var a in t)
    te.call(t, a) && (n[a] = t[a]);
  return n[ie] = r, n;
}, tt = function(r) {
  var t = r.cache, n = r.serialized, a = r.isStringTag;
  return Oe(t, n, a), Qr(function() {
    return qr(t, n, a);
  }), null;
}, nt = /* @__PURE__ */ et(function(e, r, t) {
  var n = e.css;
  typeof n == "string" && r.registered[n] !== void 0 && (n = r.registered[n]);
  var a = e[ie], s = [n], i = "";
  typeof e.className == "string" ? i = Gr(r.registered, s, e.className) : e.className != null && (i = e.className + " ");
  var f = Xr(s, void 0, F.useContext(rt));
  i += r.key + "-" + f.name;
  var u = {};
  for (var d in e)
    te.call(e, d) && d !== "css" && d !== ie && (u[d] = e[d]);
  return u.className = i, t && (u.ref = t), /* @__PURE__ */ F.createElement(F.Fragment, null, /* @__PURE__ */ F.createElement(tt, {
    cache: r,
    serialized: f,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ F.createElement(a, u));
}), Le = nt, ct = j.Fragment, ot = function(r, t, n) {
  return te.call(t, "css") ? j.jsx(Le, Fe(r, t), n) : j.jsx(r, t, n);
}, it = function(r, t, n) {
  return te.call(t, "css") ? j.jsxs(Le, Fe(r, t), n) : j.jsxs(r, t, n);
};
export {
  Le as E,
  ct as F,
  rt as T,
  it as a,
  Fe as c,
  te as h,
  qr as i,
  ot as j,
  Xr as s,
  st as u,
  et as w
};
